export const meta = {
  title: 'Troubleshooting: when something doesn’t look right',
  updatedAt: '2026-07-17',
  related: ['faq', 'notifications', 'billing'],
};

The four things operators run into most, symptom first, then exactly what to check.

## A customer can't install the app

- **Android (Chrome)** — an **Install** button appears inside your app when the browser allows it. If the customer dismissed the browser's own prompt, Chrome won't offer again in the same session — closing and reopening the browser brings the button back.
- **iPhone (Safari)** — Apple never shows an install prompt. Your app detects this and shows the three manual steps instead: open the **Share** menu, choose **Add to Home Screen**, confirm.
- Either way, installing is optional. Booking, live queue status, and payment all work in a normal browser tab.

## Notifications aren't arriving

Work down this list:

1. **Permission** — the customer must have allowed notifications when the app asked (it asks right after a booking). If they tapped block, the browser remembers: they need to re-allow it in the browser's settings for your site — the app can't re-ask on its own.
2. **iPhone** — notifications only work once the app has been added to the Home Screen; a plain Safari tab won't receive push.
3. **Expectations** — pushes fire when a ticket joins the queue, starts washing, is ready, is cancelled, or is put on hold — plus tier-up congratulations. There is **no push on collection** — a missing "receipt" notification isn't a fault; it doesn't exist.
4. **Marketing specifically** — opt-outs and quiet hours (22:00–08:00 by default) silently and correctly swallow marketing pushes. Your broadcast summary names exactly how many were skipped and why.

## A payment link expired

Two different cases:

- **A customer paying for a wash online** — payment pages are single-use and short-lived by design. The fix is simply to tap **Pay** again: every tap issues a fresh link. Abandoned attempts expire on their own and never charge anyone.
- **Your own subscription invoice** — on the Billing page, use **Regenerate** next to the invoice to get a fresh payment link. Only the newest link can settle an invoice; older ones are refused rather than risking a double charge.

## My outlet isn't showing on the public directory

Check in this order:

1. **The switch** — _Show my outlets on the public directory_, at the bottom of the Hours page, must be on. It's off by default for every new account.
2. **Outlet status** — only active outlets are listed. An outlet you've closed or removed drops off the directory automatically.
3. **Timing** — changes flow through within moments of saving. Flip the switch off and on again to force a fresh sync if you suspect a hiccup.
4. **Curation** — the network moderates the public directory and can hide a listing that breaks its rules. If you believe you're hidden by mistake, write to us via the Contact page.

## Still stuck?

The **Contact** page reaches a human within one business day — and the WhatsApp line in the footer is faster. Tell us what you saw and what you expected; screenshots help.
